import { useMemo } from 'react'

import useReduxSelector from './useReduxSelector'

const useFeatureFlag = (flag: string) => {
  const data = useReduxSelector((state) => state.featureFlags.data)

  const featureFlags = data || []

  const hasFeatureFlag = useMemo(
    () => featureFlags.indexOf(flag) > -1,
    [flag, featureFlags],
  )
  return hasFeatureFlag
}

export default useFeatureFlag
